import React, { useState, useRef, useEffect } from 'react';
import { Plus, Loader2 } from 'lucide-react';

const QuickAddTask = ({ estado, onCreate }) => {
  const [adding, setAdding] = useState(false);
  const [titulo, setTitulo] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const inputRef = useRef(null);
  // Cuando Enter dispara submit, marcamos este flag para que el blur que
  // sigue inmediatamente al desenfocar no vuelva a cancelar/cerrar.
  const guardandoRef = useRef(false);

  useEffect(() => {
    if (adding) inputRef.current?.focus();
  }, [adding]);

  const submit = async (continueAdding = false) => {
    const t = titulo.trim();
    if (!t) {
      // Sin titulo, Enter no hace nada (cerrar la sesion es trabajo de Esc/blur)
      return;
    }
    guardandoRef.current = true;
    setSubmitting(true);
    try {
      await onCreate({ titulo: t, estado_id: estado.id });
      setTitulo('');
      if (continueAdding) {
        inputRef.current?.focus();
      } else {
        setAdding(false);
      }
    } catch (err) {
      console.error('Error creando tarea:', err);
    } finally {
      setSubmitting(false);
      guardandoRef.current = false;
    }
  };

  const cancel = () => {
    setAdding(false);
    setTitulo('');
  };

  if (!adding) {
    return (
      <button
        onClick={() => setAdding(true)}
        className="w-full flex items-center gap-1.5 px-2 py-1.5 text-xs text-slate-400 hover:text-slate-700 hover:bg-slate-100/60 rounded-md transition-colors"
      >
        <Plus size={12} strokeWidth={2.5} />
        Agregar tarea
      </button>
    );
  }

  return (
    <div className="bg-white rounded-lg border border-slate-300 shadow-sm overflow-hidden focus-within:border-cyan-500 focus-within:ring-2 focus-within:ring-cyan-500/15 transition-all">
      <textarea
        ref={inputRef}
        value={titulo}
        onChange={(e) => setTitulo(e.target.value)}
        onBlur={() => {
          // Blur cancela. Si el submit acaba de dispararse por Enter
          // (guardandoRef) o estamos en medio del POST, no tocamos nada.
          if (guardandoRef.current || submitting) return;
          cancel();
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            submit(e.metaKey || e.ctrlKey);
          } else if (e.key === 'Escape') {
            e.preventDefault();
            cancel();
          }
        }}
        rows={2}
        placeholder="Título de la tarea..."
        disabled={submitting}
        className="w-full px-2.5 py-2 text-sm bg-transparent placeholder-slate-400 focus:outline-none resize-none disabled:opacity-50"
      />
      <div className="flex items-center justify-between px-2.5 pb-1.5 text-[10px] text-slate-400">
        <div className="flex items-center gap-2">
          <span className="inline-flex items-center gap-1">
            <kbd className="px-1 text-[9px] font-mono font-medium bg-white text-slate-500 border border-slate-200 rounded">Enter</kbd>
            guarda
          </span>
          <span className="inline-flex items-center gap-1">
            <kbd className="px-1 text-[9px] font-mono font-medium bg-white text-slate-500 border border-slate-200 rounded">Esc</kbd>
            cancela
          </span>
        </div>
        {submitting && <Loader2 size={11} className="animate-spin" />}
      </div>
    </div>
  );
};

export default QuickAddTask;
